import { useObserver, useSubtree } from "subtree.js/react";
import { PAGE_WIDE } from "../../components/CardPhotos";
import { LoadFailed, Loading } from "../../components/LoadState";
import { SheetBack } from "../../components/SheetBack";
import { UnrecognisedScan } from "../../components/UnrecognisedScan";
import { ScanEditor } from "../../sections/scan-editor/scan-editor";
import { EditScanActions, EditScanState } from "./edit-scan-model";

export function EditScanPage() {
  const state = useSubtree(EditScanState);
  const actions = useSubtree(EditScanActions);
  const observer = useObserver();
  const status = observer.watch(state.status);
  const noMatch = observer.watch(state.noMatch);

  if (noMatch)
    return (
      <div className="mx-auto max-w-3xl px-4 py-4 sm:px-5">
        <SheetBack onBack={actions.cancel} />
        <UnrecognisedScan scan={noMatch} uploadLink />
      </div>
    );

  return (
    <div className={`mx-auto max-w-[700px] px-4 py-4 sm:px-5 ${PAGE_WIDE}`}>
      {status !== "ready" && <SheetBack onBack={actions.cancel} />}
      {status === "loading" && <Loading label="Loading the scan…" />}
      {status === "notFound" && <p className="py-4 text-sm text-muted">This scan no longer exists.</p>}
      {status === "error" && <LoadFailed title="Couldn't load this scan." onRetry={actions.retry} />}
      {status === "ready" && (
        <ScanEditor
          header={{
            onBack: actions.cancel,
            position: state.position,
            onSkip: state.canSkip ? actions.skip : null,
          }}
        />
      )}
    </div>
  );
}
